const getters = {
    GetUserInfo: state => state.user.userinfo,
    getmapstate: state => state.user.mapstate
}

export default getters